"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var tubular_common_1 = require("tubular-common");

var getRemoteDataSource = function getRemoteDataSource(request) {
  return function (gridRequest) {
    return __awaiter(void 0, void 0, void 0, function () {
      var httpCast, httpClient, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            httpCast = request;
            httpClient = httpCast.request ? httpCast : new tubular_common_1.TubularHttpClient(request);
            return [4
            /*yield*/
            , httpClient.fetch(gridRequest)];

          case 1:
            data = _a.sent();

            if (!tubular_common_1.TubularHttpClient.isValidResponse(data)) {
              throw new Error('Server response is a invalid Tubular object');
            }

            data.Payload = data.Payload.map(function (row) {
              return tubular_common_1.parsePayload(row, gridRequest.Columns);
            });
            return [2
            /*return*/
            , data];
        }
      });
    });
  };
};

var getLocalDataSource = function getLocalDataSource(source) {
  return function (request) {
    return new Promise(function (resolve, reject) {
      try {
        resolve(tubular_common_1["default"].getResponse(request, source));
      } catch (error) {
        reject(error);
      }
    });
  };
};

var useDataGrid = function useDataGrid(initColumns, config, source, deps) {
  var _a = React.useState(false),
      isLoading = _a[0],
      setIsLoading = _a[1];

  var _b = React.useState(initColumns),
      getColumns = _b[0],
      setColumns = _b[1];

  var _c = React.useState(false),
      initialized = _c[0],
      setInitialized = _c[1];

  var _d = React.useState(null),
      getActiveColumn = _d[0],
      setActiveColumn = _d[1];

  var _e = React.useState(false),
      getMultiSort = _e[0],
      setMultiSort = _e[1];

  var _f = React.useState(config.itemsPerPage || 10),
      getItemsPerPage = _f[0],
      setItemsPerPage = _f[1];

  var getStorage = React.useState(config.storage || new tubular_common_1.NullStorage())[0];

  var _g = React.useState(config.page || 0),
      getPage = _g[0],
      setPage = _g[1];

  var _h = React.useState(config.searchText || ''),
      getSearchText = _h[0],
      setSearchText = _h[1];

  var _j = React.useState(null),
      getError = _j[0],
      setError = _j[1];

  var getAllRecords = source instanceof Array ? getLocalDataSource(source) : getRemoteDataSource(source);

  var _k = React.useState({
    aggregate: null,
    data: [],
    filteredRecordCount: 0,
    totalRecordCount: 0
  }),
      getState = _k[0],
      setState = _k[1];

  if (getStorage instanceof tubular_common_1.LocalStorage) {
    getStorage.setGridName(config.gridName);
  }

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Control' && !getMultiSort) {
      setMultiSort(true);
    }
  };

  var handleKeyUp = function handleKeyUp(event) {
    if (event.key === 'Control' && getMultiSort) {
      setMultiSort(false);
    }
  };

  var api = {
    exportTo: function exportTo(allRows, exportFunc) {
      return __awaiter(void 0, void 0, void 0, function () {
        var payload, Payload;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (getState.filteredRecordCount === 0) {
                return [2
                /*return*/
                ];
              }

              payload = getState.data;
              if (!allRows) return [3
              /*break*/
              , 2];
              return [4
              /*yield*/
              , getAllRecords(new tubular_common_1.GridRequest(getColumns, -1, 0, getSearchText))];

            case 1:
              Payload = _a.sent().Payload;
              payload = Payload;
              _a.label = 2;

            case 2:
              exportFunc(payload, getColumns);
              return [2
              /*return*/
              ];
          }
        });
      });
    },
    goToPage: function goToPage(page) {
      if (getPage !== page) {
        setPage(page);
      }
    },
    handleFilterChange: function handleFilterChange(value) {
      setActiveColumn(__assign(__assign({}, getActiveColumn), {
        Filter: __assign(__assign({}, getActiveColumn.Filter), value)
      }));
    },
    processRequest: function processRequest() {
      return __awaiter(void 0, void 0, void 0, function () {
        var request, response, maxPage, currentPage, err_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              setIsLoading(true);
              _a.label = 1;

            case 1:
              _a.trys.push([1, 3,, 4]);

              request = new tubular_common_1.GridRequest(getColumns, getItemsPerPage, getPage, getSearchText);
              return [4
              /*yield*/
              , getAllRecords(request)];

            case 2:
              response = _a.sent();
              maxPage = Math.ceil(response.TotalRecordCount / getItemsPerPage);
              currentPage = response.CurrentPage > maxPage ? maxPage : response.CurrentPage;
              currentPage = currentPage === 0 ? 0 : currentPage - 1;
              getStorage.setPage(currentPage);
              getStorage.setColumns(getColumns);
              getStorage.setTextSearch(getSearchText);
              setState({
                aggregate: response.AggregationPayload,
                data: response.Payload,
                filteredRecordCount: response.FilteredRecordCount || 0,
                totalRecordCount: response.TotalRecordCount || 0
              });
              setIsLoading(false);
              setInitialized(true);
              setError(null);
              setPage(currentPage);
              return [3
              /*break*/
              , 4];

            case 3:
              err_1 = _a.sent();

              if (config.onError) {
                config.onError(err_1);
              }

              setIsLoading(false);
              setError(err_1);
              return [3
              /*break*/
              , 4];

            case 4:
              return [2
              /*return*/
              ];
          }
        });
      });
    },
    setActiveColumn: setActiveColumn,
    setFilter: function setFilter(value) {
      var columns = __spreadArrays(getColumns);

      var column = columns.find(function (c) {
        return c.Name === getActiveColumn.Name;
      });

      if (!column) {
        return;
      }

      column.Filter = __assign(__assign({}, getActiveColumn.Filter), value);
      setColumns(__spreadArrays(columns));
    },
    sortColumn: function sortColumn(property) {
      var columns = tubular_common_1.ColumnModel.sortColumnArray(property, __spreadArrays(getColumns), getMultiSort);
      setColumns(columns);
    },
    updateItemPerPage: function updateItemPerPage(itemsPerPage) {
      if (getItemsPerPage !== itemsPerPage) {
        setItemsPerPage(itemsPerPage);
      }
    },
    updateSearchText: function updateSearchText(searchText) {
      if (getSearchText !== searchText) {
        setSearchText(searchText);
      }
    }
  };
  var dependencies = [getColumns, getPage, getSearchText, getItemsPerPage, source];

  if (deps) {
    dependencies = dependencies.concat(deps);
  }

  React.useEffect(function () {
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', handleKeyUp);
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, [getMultiSort]);
  React.useEffect(function () {
    api.processRequest();
  }, dependencies);
  React.useEffect(function () {
    setColumns(initColumns);
  }, [initColumns]);

  var initGrid = function initGrid() {
    if (getStorage.getPage()) {
      setPage(getStorage.getPage());
    }

    var storedColumns = getStorage.getColumns();

    if (storedColumns) {
      var columns_1 = __spreadArrays(getColumns);

      storedColumns.forEach(function (column) {
        var currentColumn = columns_1.find(function (col) {
          return col.Name === column.Name;
        });

        if (!currentColumn) {
          return;
        }

        currentColumn.Visible = column.Visible;

        if (currentColumn.Filter !== null && currentColumn.Filter.Text !== null) {
          return;
        }

        if (column.Filter != null && column.Filter.Text != null && column.Filter.Operator !== tubular_common_1.CompareOperators.NONE) {
          currentColumn.Filter = column.Filter;
        }
      });
      setColumns(columns_1);
    }

    setInitialized(true);
  };

  if (!initialized) {
    initGrid();
  }

  var state = __assign(__assign({}, getState), {
    activeColumn: getActiveColumn,
    columns: getColumns,
    error: getError,
    initialized: initialized,
    isLoading: isLoading,
    itemsPerPage: getItemsPerPage,
    multiSort: getMultiSort,
    page: getPage,
    searchText: getSearchText,
    storage: getStorage
  });

  var result = {
    api: api,
    state: state
  };
  return result;
};

exports["default"] = useDataGrid;